import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '@techspert-io/auth';
import { Observable } from 'rxjs';
import { publishReplay, refCount } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TemplatesService {
  private cache$: Record<string, Observable<string>> = {};

  constructor(
    private http: HttpClient,
    @Inject(WINDOW) private window: Window
  ) {}

  footerLookUp(): Observable<string> {
    return this.getCachedFooter();
  }

  private getCachedFooter(): Observable<string> {
    if (!this.cache$['generic']) {
      this.cache$['generic'] = this.getFooter().pipe(
        publishReplay(1),
        refCount()
      );
    }
    return this.cache$['generic'];
  }

  private getFooter(): Observable<string> {
    return this.http.get(
      `${this.window.location.protocol}//${this.window.location.host}/assets/templates/footers/generic.html`,
      {
        responseType: 'text',
      }
    );
  }
}
